import * as PIXI from "pixi.js";

// imports para o bundler copiar p/ /public/img

import house from "../img/house.png";
import cto from "../img/cto.png";
import marker from "../img/marker.png";
import markerCircle from "../img/circulo.png";
import focusCto from "../img/focus-circulo.png";
import focusHouse from "../img/focus-marker.png";

import { useEffect, useState } from "react";

export default function useTextures() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      const { Assets } = PIXI;

      const texList = [
        { id: "marker_house", src: house },
        { id: "marker_cto", src: cto },
        { id: "cto", src: markerCircle },
        { id: "house", src: marker },
        { id: "focus-house", src: focusHouse },
        { id: "focus-cto", src: focusCto },
      ];

      texList.forEach(({ id, src }) => {
        if (!Assets.cache.has(id)) Assets.add(id, src);
      });

      await Promise.all(texList.map(({ id }) => Assets.load(id)));
      setReady(true);
    })();
  }, []);

  return ready;
}
